import type { ScormModuleStatus } from '@zeus/index'
import { matchesQuery } from '~/utils/search-text'

export type ModuleFilters = {
  query: string
  /** Vide pour tous. */
  status: ScormModuleStatus | ''
}

type FilterableModule = { title: string, status: ScormModuleStatus }

/** Modules dont le titre répond à la recherche, au statut demandé (#107). */
export function filterModules<T extends FilterableModule>(modules: readonly T[], filters: ModuleFilters): T[] {
  return modules.filter(module =>
    (!filters.status || module.status === filters.status)
    && matchesQuery(filters.query, [module.title]))
}
